import A11yNavigation from 'a11y-navigation'
import Navigation from './navigation'

// Keep this up-to-date with the breakpoint variable in styles.scss
const breakpoint = '60rem'

const nav = document.querySelector('.js-nav')

if (nav) {
  // eslint-disable-next-line no-new
  new A11yNavigation({
    el: nav
  })
}

const navButtons = document.querySelectorAll('.js-navigation-button')

if (navButtons.length) {
  new Navigation({
    trigger: navButtons,
    target: 'navigation-content',
    breakpoint: window.matchMedia(`(min-width: ${breakpoint})`)
  }).init()
}

const contactButtons = document.querySelectorAll('.js-navigation-contact')

if (contactButtons.length) {
  new Navigation({
    trigger: contactButtons,
    target: 'navigation-contact',
    breakpoint: window.matchMedia(`(min-width: ${breakpoint})`)
  }).init()
}



// WEBPACK FOOTER //
// ./src/components/navigation/scripts.js